import usePersistantState from "src/hooks/usePersistantState";
import CheckBox from "./CheckBox";
import { useEffect, useState } from "react";
import CatchyCheckbox from "../CatchyCheckbox/CatchyCheckbox";
import { ToastContainer, toast } from "react-toastify";

export default function FormCheckboxSingle({
  single,
  handleState,
  state,
  index,
  type = 1,
  gozineType = 1,
  maxFive = 999,
  maxFour = 999,
}) {
  let chosenType;

  let type1 = {
    "بی اهمیت": 0,
    "کم اهمیت": 1,
    لازم: 2,
    "نسبتا ضروری": 3,
    ضروری: 4,
    "خیلی ضروری": 5,
  };
  let type2 = {
    "خیلی کم": 0,
    کم: 1,
    متوسط: 2,
    زیاد: 3,
    "خیلی زیاد": 4,
  };
  if (gozineType == 1) {
    chosenType = JSON.parse(JSON.stringify(type1));
  } else {
    chosenType = JSON.parse(JSON.stringify(type2));
  }
  let chosenTypeOption = JSON.parse(JSON.stringify(chosenType));
  Object.keys(chosenTypeOption).forEach((key) => {
    chosenTypeOption[key] = false;
  });
  const [options, setOptions] = useState(chosenTypeOption);
  const [isFirst, setIsFirst] = useState(true);
  useEffect(() => {
    Object.keys(chosenType).forEach((key) => {
      if (chosenType[key] == state[single].value && isFirst) {
        handleOptions(key);
        setIsFirst(false);
      }
    });
  }, [state]);

  const handleOptions = (key) => {
    Object.keys(options).forEach((key) => {
      if (options[key]) {
        options[key] = false;
      }
    });
    setOptions({
      ...options,
      [key]: !options[key],
    });
    let newOption = {
      ...options,
      [key]: !options[key],
    };
    handleState({
      ...state,
      [single]: {
        newItem: state[single].newItem ? true : false,
        value: chosenType[key],
        desc: state[single].desc,
      },
    });
  };

  const salam = (key) => {
    let FiveCount = 0;
    let FourCount = 0;
    Object.values(state).forEach((single) => {
      if (single.value == 5) {
        ++FiveCount;
      }
      if (single.value == 4) {
        ++FourCount;
      }
    });
    if (FiveCount >= maxFive && key == Object.keys(chosenType)[5]) {
      toast.error(
        `شما حداکثر می‌توانید ${maxFive} مورد ${
          Object.keys(chosenType)[5]
        } انتخاب کنید`
      );
    } else if (FourCount >= maxFour && key == Object.keys(chosenType)[4]) {
      toast.error(
        `شما حداکثر می‌توانید ${maxFour} مورد ${
          Object.keys(chosenType)[4]
        } انتخاب کنید`
      );
    } else {
      handleOptions(key);
    }
  };

  const handleInputChange = (e) => {
    let newState = {
      ...state,
    };
    delete newState[Object.keys(newState)[index]];
    newState[e.target.value] = {
      newItem: true,
      value: null,
      desc: "",
    };
    handleState(newState);
  };
  const optionsJSX = Object.keys(options).map((key, index) => (
    <CatchyCheckbox
      key={index}
      label={key}
      data={options}
      handleCheck={() => salam(key)}
    />
  ));

  const removeItem = (keyName) => {
    const newObject = { ...state };
    delete newObject[keyName];
    handleState(newObject);
  };

  return (
    <>
      {type == 1 ? (
        <div className="mt-8 flex flex-col space-y-4">
          <div>
            {single && (state[single].value || state[single].value === 0) ? (
              <div className="flex gap-2 justify-start">
                {!!state[single].newItem ? (
                  <img
                    onClick={() => removeItem(single)}
                    src="assets/img/close-circle-rose-400.svg"
                    className="w-6 h-6 cursor-pointer ml-2"
                  />
                ) : null}
                <span className="font-bold text-gray-700">{single}</span>
                <span className="text-[13px] text-[#7A7A7A]">
                  {state[single].desc}
                </span>
              </div>
            ) : (
              <div className="border border-solid border-gray-400 p-2 rounded flex justify-between">
                <input
                  type="text"
                  className="w-full"
                  placeholder="مورد جدید موردنظر را در این قسمت وارد کنید"
                  onBlur={(e) => handleInputChange(e)}
                />
                <img
                  onClick={() => removeItem(single)}
                  src="assets/img/close-circle-rose-400.svg"
                  className="w-6 h-6 cursor-pointer"
                />
              </div>
            )}
          </div>
          <div className="text-[14px] text-[#7A7A7A] flex flex-row space-x-5 justify-between">
            {optionsJSX}
          </div>
        </div>
      ) : (
        <div className="flex flex-row items-center border border-solid border-gray-300">
          <div className="border-l w-64">
            {single && (state[single].value || state[single].value === 0) ? (
              <div className="flex justify-start p-4">
                {!!state[single].newItem ? (
                  <img
                    onClick={() => removeItem(single)}
                    src="assets/img/close-circle-rose-400.svg"
                    className="w-6 h-6 cursor-pointer ml-2"
                  />
                ) : null}
                <span>{single} ‌ ‌</span>
                <span className="text-[13px] text-[#7A7A7A]">
                  {state[single].desc}
                </span>
              </div>
            ) : (
              <div className="py-4 p-2 rounded">
                <input
                  type="text"
                  className="w-full"
                  placeholder="مورد جدید را اینجا وارد کنید"
                  onBlur={(e) => handleInputChange(e)}
                />
                <img
                  onClick={() => removeItem(single)}
                  src="assets/img/close-circle-rose-400.svg"
                  className="w-6 h-6 cursor-pointer"
                />
              </div>
            )}
          </div>
          <div className="w-full flex justify-between text-[11px] text-[#7A7A7A] space-x-2 p-2">
            {optionsJSX}
          </div>
        </div>
      )}
    </>
  );
}
